import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=0595bbc8&"
import script from "./MenuMobile.vue?vue&type=script&lang=js&"
export * from "./MenuMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports